import * as React from "react";
import { useState } from "react";
import { Typography, Box, Divider } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "@mui/material";

export function CenterTile(props) {
    let [textChange, setTextChange] = useState(false);
    let location = useLocation();
    const inGallery =  useMediaQuery('(min-width:3000px)');

    return (
        <Box
            sx={{
                backgroundColor: "secondary.main",
                minWidth: "315px",
                height: "16%",
                minHeight: "110px",
                position: "absolute",
                top: "max(275px,50%)", // This is a percentage of the parent
                left: "50%", // This is a percentage of the parent
                transform: `translate(-50%, ${inGallery ? "-55%" : "-55%"})`, //Translate percentage is based on the element's size, not parent
                borderRadius: "max(12px,2.315vh)",
                aspectRatio: "1172/409",
                animation: props.exitPage
                        ? `${props.exitDelay/1000}s ease fade-out forwards`
                        : "",
            }}
        >
            <Box
                sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    borderWidth: {
                        xl: "20px",
                        lg: "16px",
                    },
                    borderStyle: "solid",
                    borderColor: "primary.main",
                    borderRadius: "max(12px,2.315vh)",
                    backgroundColor: "primary.main",
                    animation: props.exitPage
                        ? props.exitAnimation
                        : location.state === "from profile"
                        ? "fade-in 2s ease forwards"
                        : "",
                    aspectRatio: "1172/409"
                }}
            >
                <Typography
                    component="h2"
                    sx={{
                        fontFamily: "WindsorD-Bol",
                        fontSize: "max(12px, 2.315vh)",
                        lineHeight: "max(17px, 3.24vh)",
                        letterSpacing: "1px",
                        color: "text.primary",
                        justifySelf: "end",
                    }}
                >
                    We. The Culture:
                </Typography>
                <Typography
                    component="h2"
                    sx={{
                        fontSize: "max(12px, 1.11vh)",
                        lineHeight: "max(10px, 1.30vh)",
                        letterSpacing: ".1333vh",
                        textTransform: "uppercase",
                        marginBottom: "max(2.4px, 0.787vh)",
                        color: "text.primary",
                    }}
                >
                    Works By the Eighteen Art Collective
                </Typography>
                <Divider
                    sx={{
                        borderColor: "text.primary",
                        borderWidth: "1px",
                        width: "90%",
                    }}
                />
                <Typography
                    component="h1"
                    sx={{
                        fontFamily: "WindsorD-Bol",
                        fontSize: "max(31.8px,5vh)",
                        lineHeight: "max(44.5px,6.426vh)",
                        letterSpacing: ".1204vh",
                        color: "text.primary",
                    }}
                >
                    Meet the Artists
                </Typography>
                <Divider
                    sx={{
                        borderColor: "text.primary",
                        borderWidth: "1px",
                        width: "90%",
                    }}
                />
                {textChange && location.state ? (
                    <Typography
                        component="h2"
                        sx={{
                            fontSize: "max(12px, 1.389vh)",
                            lineHeight: "max(12px, 1.620vh)",
                            letterSpacing: "0.6px",
                            marginTop: "max(2.4px, .787vh)",
                            color: "text.primary",
                            animation: "fade-in 1.2s backwards ease",
                        }}
                    >
                        {props.text2}
                    </Typography>
                ) : (
                    <Typography
                        sx={{
                            fontSize: "max(12px,1.389vh)",
                            lineHeight: "max(12px, 1.620vh)",
                            letterSpacing: "0.6px",
                            marginTop: "max(2.4px, .787vh)",
                            color: "text.primary",
                            animation: location.state
                                ? "fade-out 1.2s forwards ease"
                                : "",
                        }}
                        onAnimationEnd={() => {
                            setTextChange(true);
                        }}
                    >
                        {location.state !== "from profile" ? props.text1 : "​"}
                    </Typography>
                )}
            </Box>
        </Box>
    );
}
